import React from 'react'

import ReactMarkdown from 'react-markdown'
import MarkdownHelper from '../utils/MarkdownHelper'

const colors = {
    Default: 'default',
    Base: 'base',
    FTL: 'ftl',
    SENATOR: 'sen',
    HON: 'hon'
}

class Flag extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            source: ''
        }
    }

    componentDidMount() {
        this.setState({source: this.props.text});
    }

    componentDidUpdate(prevProps) {
        if (this.props.text !== prevProps.text) {
            this.setState({source: this.props.text});
        }
    }

    render() {
        return (
            this.props.text && this.props.appearance ?
                <div className={'flag js-mam-symbol-content' + (this.props.appearance ? ' ' + colors[this.props.appearance] : '')}>
                    <ReactMarkdown {...MarkdownHelper.allTypes()}
                                   source={this.state.source} />
                </div>  :
                null
        )
    }

}

export default Flag



// WEBPACK FOOTER //
// ./src/components/subcomponents/Flag.js